import axios from 'axios';

export default {

    async getGroupInfo(gid) {
        if (!localStorage.token) throw 'token must not be undefined'
        if (!gid) throw 'gid must not be undefined'

        const response = await axios.get('https://graph.facebook.com/v2.11/' + gid, {
            params: {access_token: localStorage.token, fields: 'cover,name,description'}
        })
        return response.data
    },

    async getInfoUsersMap(uids) {
        const response = await axios.get('https://graph.facebook.com/v1.0/fql', {
            params: {
                access_token: localStorage.token,
                q: "SELECT uid,pic_big,name,birthday,sex,hometown_location,current_location,work_history,education_history FROM user WHERE uid IN (" + _(uids).join(",") + ")"
            }
        })

        var users = response.data.data
        return _.reduce(users, (result, user) => {
            result[user.uid] = user
            return result;
        }, {});
    },

    async fetchInfoUsers({uids}) {
        const response = await axios.get('https://graph.facebook.com/v1.0/fql', {
            params: {
                access_token: localStorage.token,
                q: "SELECT uid,pic_big,name,birthday,sex,hometown_location,current_location,work_history,education_history FROM user WHERE uid IN (" + _(uids).join(",") + ")"
            }
        })
        var infoUsers = response.data.data
        return {data: infoUsers}
    },

    /**
     * Exand all posts / comments / sub comments => array
     * @param posts
     * @returns {Array}
     */
    expandTalks(posts) {
        var data = []

        if (posts === undefined) {
            return data
        }

        if (!(posts instanceof Array)) posts = [posts]

        for (let post of posts) {
            data.push(post)

            if (!post.comments) continue

            for (let comment of post.comments.data) {
                data.push(comment)

                if (!comment.comments) continue

                for (let sub_comment of comment.comments.data) {
                    data.push(sub_comment)
                }
            }
        }
        return data
    },
    /**
     * Expand all from ignore undefined
     * @param posts
     * @returns {Array}
     */
    expandFroms(posts) {
        var froms = []

        if (posts === undefined) {
            return froms
        }

        if (!(posts instanceof Array)) posts = [posts]

        for (let post of posts) {
            if (post.from) froms.push(post.from)

            if (!post.comments) continue

            for (let comment of post.comments.data) {
                if (comment.from) froms.push(comment.from)

                if (!comment.comments) continue

                for (let sub_comment of comment.comments.data) {
                    if (sub_comment.from) froms.push(sub_comment.from)
                }
            }
        }
        return froms
    }

}



// WEBPACK FOOTER //
// ./src/libs/fb-helper.js